import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { Box, Flex, IconPadlock, IconStripe, Span, Text } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var StripeTrustBadge = function StripeTrustBadge(props) {
  return ___EmotionJSX(Flex, _extends({
    alignItems: "center"
  }, props), ___EmotionJSX(IconPadlock, {
    mr: 1
  }), ___EmotionJSX(Text, {
    my: 0,
    mr: 2
  }, "Guaranteed ", ___EmotionJSX(Span, {
    fontWeight: "bold"
  }, "safe & secure")), ___EmotionJSX(Box, {
    width: "auto",
    borderRadius: "default"
  }, ___EmotionJSX(IconStripe, {
    width: "auto"
  })));
};